
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/userProduct",
      function () {
        return require("private-next-pages/userProduct/index.tsx");
      }
    ]);
  